module.exports = __webpack_public_path__ + "static/media/categories.06a6727b.svg";